import React, { useState } from "react";
import LayOut from "../components/LayOut";
import "./Styles/login.css";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { useAuth } from "../context/Auth"; // ✅ import useAuth

const Login = () => {
  const [auth, setAuth] = useAuth(); // ✅ context se auth lena hoga
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      return toast.error("All fields are required");
    }

    try {
      const response = await axios.post(
        "https://portfoliomern-mxue.onrender.com/api/v1/auth/login",
        {
          email: formData.email,
          password: formData.password,
        }
      );

      if (response.data.success) {
        const { user, token } = response.data;

        // ✅ Update context state properly
        setAuth({ user, token });

        // ✅ Store to localStorage
        localStorage.setItem("auth", JSON.stringify({ user, token }));

        // ✅ Set axios default auth header
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        toast.success("Login Successfully");

        // ✅ Redirect
        navigate("/");
      } else {
        toast.error(response.data.message || "Login failed");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    }
  };

  return (
    <LayOut title={"Login Page"}>
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="login-container">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="email"
                className="form-control"
                placeholder="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 text-center">
              <button type="submit" className="btn btn-pink w-100">
                Login
              </button>
            </div>
            <p className="text-center">
              <Link to="/forgot-password">Forgot-Password</Link>
            </p>
            <p className="text-center">
              Don't have an account? <Link to="/register">Register</Link>
            </p>
          </form>
        </div>
      </div>
    </LayOut>
  );
};

export default Login;
